<template>
  <v-dialog
    scrollable
    v-model="visible"
    max-width="900px"
    :fullscreen="fullscreen"
    :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">查看</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12>
              <div class="x-text-field">
                <label>组织单位</label>
                <div>{{item.organizer}}</div>
              </div>
            </v-flex>

            <v-flex xs6>
              <div class="x-text-field">
                <label>结项时间</label>
                <div>{{item.examineDate}}</div>
              </div>
            </v-flex>

            <v-flex xs6>
              <div class="x-text-field">
                <label>结项编号</label>
                <div>{{item.number}}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>项目状态</label>
                <div>{{ item.projStatus? item.projStatus.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>结项类型</label>
                <div>{{ item.conclType? item.conclType.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>结项结论</label>
                <div>{{ item.conclLevel? item.conclLevel.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs3>
              <div class="x-text-field">
                <label>成果水平</label>
                <div>{{ item.achivLevel? item.achivLevel.name : '' }}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>专家组成员</label>
                <div>{{item.experts}}</div>
              </div>
            </v-flex>

            <v-flex xs12>
              <div class="x-text-field">
                <label>备注</label>
                <div>{{item.note}}</div>
              </div>
            </v-flex>

          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="primary" @click.native="visible=false">关闭</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import mixin from '@/mixin'

  const baseUri = '/api/proj/conclusion';

  export default {
    mixins: [mixin.view(baseUri)],

    data() {
      return {
        item: {
          "projStatus": {},
          "conclType": {},
          "conclLevel": {},
          "achivLevel": {}
        }
      }
    }
  }
</script>
